import { inject, Injectable } from '@angular/core';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { IconsMockApi } from 'app/mock-api/ui/icons/api';

@Injectable({ providedIn: 'root' })
export class MockApiService {
    iconsMockApi = inject(IconsMockApi);
    navigationMockApi = inject(NavigationMockApi);

}
